import React, { useState, useEffect, useRef } from "react";
// import { Breadcrumb, Button, Card, CardBody, CardHeader, Col, Container, Nav, Row, Stack } from "react-bootstrap";
import {
  Button, Breadcrumb, Card, CardBody, CardHeader, Col, Container, Form, Row, Stack,
  Table, Spinner, FormControl, FormSelect, Badge, Popover, OverlayTrigger
} from "react-bootstrap";
import Select from 'react-select';
import Confirm from "../Confirm";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import FilesCreate from "../File/FilesCreate";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import RelatedListFiles from "../File/RelatedListFiles";
// import * as constants from "../../constants/CONSTANT";
import Image from "react-bootstrap/Image";
import moment from "moment";
import { disableCursor } from "@fullcalendar/core/internal";
import { ROUTES } from "../../constants/WebRouting";
import trasportApi from "../../api/trasportApi";
import { formatDate } from "../../utils/helper";
import { DatatableWrapper, TableBody, TableHeader } from "react-bs-datatable";
import RelatedListServiceOrder from "./RelatedListServiceOrder";
import Main from "../layout/Main";
import PaymentRelatedList from "./PaymentRelatedList"
import PaymentEdit from "./PaymentEdit";


const ServiceOrderView = (props) => {
  console.log('ServiceOrderView Call');
  const location = useLocation();
  const navigate = useNavigate();
  console.log("location.state 123", location.state);
  const [serviceOrder, setServiceOrder] = useState(location.state ? location.state : {});

  console.log("ServiceOrderView id", serviceOrder.id);

  const [modalShow, setModalShow] = useState(false);
  const [modalShowFile, setModalShowFile] = useState(false);
  const [modalShowTask, setModalShowTask] = useState(false);
  const [modalShowPayment, setModalShowPayment] = useState(false);
  const [refreshPaymentList, setRefreshPaymentList] = useState();
  const [payments, setPayments] = useState({}); // For Payments Tracking Use.

  const [relatedListFiles, setRelatedListFiles] = useState(true);
  const [relatedListTask, setRelatedListTask] = useState(false);
  const [purchaseLineItem, setPurchaseLineItem] = useState(false);

  const [refreshFileList, setRefreshFileList] = useState();
  const [refreshTaskList, setRefreshTaskList] = useState();
  const [relatedListPayment, setRelatedListPayment] = useState(false);
  const invoiceRef = useRef();
  const [receivedPayment, setReceivedPayment] = useState(0);
  // useEffect(() => {
  //   let userInfoJWT = jwt_decode(localStorage.getItem("token"));
  //   setUserInfo(userInfoJWT);
  //   fetchOffer();
  //   userInfoJWT.id === order.owner_id && setDisableEdit(false);
  // }, []);

  useEffect(() => {
    fetchData();
  }, [])

  // const fetchOffer = () => {
  //   if (
  //     !order.id &&
  //     location.hasOwnProperty("pathname") &&
  //     location.pathname.split("/").length >= 3
  //   ) {
  //     order.id = location.pathname.split("/")[2];
  //   }
  //   async function init() {
  //     let result = await trasportApi.fetchOrderById(order.id);
  //     const fetchPayment = await trasportApi.fetchOrderWisePayments(order.id); //Using to Fetch Payments Record Wise By id

  //     if (result) {
  //       setOrder(result);
  //     } else {
  //       setOrder({});
  //     }
  //     if (fetchPayment) {
  //       setPayments(fetchPayment);
  //     } else {
  //       setPayments({});
  //     }
  //   }
  //   init();
  // };






  const fetchData = () => {
    if (!serviceOrder.id && location.hasOwnProperty("pathname")) {
      serviceOrder.id = location.pathname.split("/")[2];
    }
    async function init() {
      let result = await trasportApi.fetchServiceOrderById(serviceOrder?.id);
      const fetchPayment = 0 //await trasportApi.fetchOrderWisePayments(serviceOrder.id); //Using to Fetch Payments Record Wise By id
      console.log("fetchPayment", fetchPayment);

      if (result) {
        setServiceOrder(result);
      } else {
        setServiceOrder({});
      }
      if (fetchPayment) {
        setPayments(fetchPayment);
      } else {
        setPayments({});
      }

    }
    init();
  };



  const submitTasks = () => {
    setModalShowTask(false);
    setRefreshTaskList(Date.now());
  };

  const handleSelect = (key) => {
    if (key === "files") {
      setRelatedListFiles(true);
      setRelatedListTask(false);
      setPurchaseLineItem(false);
      setRelatedListPayment(false);
    } else if (key === "tasks") {
      setRelatedListFiles(false);
      setRelatedListTask(true);
      setPurchaseLineItem(false);
      setRelatedListPayment(false);
    } else if (key === "purchase_item") {
      setRelatedListFiles(false);
      setRelatedListTask(false);
      setPurchaseLineItem(true);
      setRelatedListPayment(false);
    }
    else if (key === "payment") {
      setRelatedListPayment(true);
      setRelatedListFiles(false);
      setRelatedListTask(false);
      setPurchaseLineItem(false);
    }
  };

  const submitFiles = () => {
    setModalShowFile(false);
    setRefreshFileList(Date.now());
    setModalShowTask(false);
  };

  const deleteRecord = async () => {
    const result = await trasportApi.deleteServiceOrderById(serviceOrder.id);
    if (result.success) navigate(ROUTES.SERVICE_ORDER.LIST);
  };

  const editRecord = () => {
    navigate(`${ROUTES.SERVICE_ORDER.LIST}/${serviceOrder.id}/e`, { state: serviceOrder});
  };
  
  // const editRecord = () => {
  //   navigate(`${ROUTES.SERVICE_ORDER.LIST}/${serviceOrder.id}/e`, { state: {serviceOrder , payments}});
  // };

  // const handleDownloadPdf = () => {
  //   const doc = new jsPDF("p", "pt", "a4");
  //   const pageWidth = doc.internal.pageSize.getWidth();

  //   // 1) Centered Title, Invoice No & Date
  //   const logoData = '/soiree_salon_logo.jpeg'; // Replace with your Base64 image
  //   doc.addImage(logoData, 'PNG', 40, 30, 50, 50)

  //   doc.setFontSize(18);
  //   doc.text("INVOICE", pageWidth / 2, 40, { align: "center" });

  //   doc.setFontSize(12);
  //   doc.text(
  //     "Invoice No: INV‑2025",
  //     pageWidth / 2,
  //     65,
  //     { align: "center" }
  //   );
  //   // doc.text(
  //   //   `Date: ${new Date().toLocaleDateString()}`,
  //   //   pageWidth / 2,
  //   //   85,
  //   //   { align: "center" }
  //   // );

  //   // 2) Table of line‑items, with grid lines

  //   // const headers = [["Customer Name", "Product Name", "Price", "Service Date", "Total"]];

  //   // const rows = [
  //   //   ["Test Contact", "Conditioner", "₹1,000", "21-05-2025", "₹1,000"],
  //   //   ["Google Contact", "Hair Oil", "₹1,250", "22-05-2025", "₹1,250"],
  //   //   ["Architect Contact", "Nail Polish & Pedicure", "₹500", "23-05-2025", "₹500"],
  //   //   ["iBirds contact", "Cuticle Oil", "₹1,000", "24-05-2025", "₹1,000"],
  //   //   ["Supplier Contact", "Face Packs", "₹1,250", "25-05-2025", "₹1,250"],
  //   //   ["Customer Contact", "Bleach Cream", "₹500", "26-05-2025", "₹500"],
  //   //   ["Enquiry Customer Contact", "Body Lotion", "₹1,000", "27-05-2025", "₹1,000"],
  //   //   ["Contractor Contact", "Wax", "₹1,250", "28-05-2025", "₹1,250"],
  //   //   ["Dealer Contact", "Foundation", "₹500", "29-05-2025", "₹500"],
  //   // ];
  //   // rows.push([
  //   //   { content: "Sub Total", colSpan: 4, styles: { halign: "right", fontStyle: "bold" } },
  //   //   "₹2,750"
  //   // ]);

  //   // doc.autoTable({
  //   //   startY: 110,
  //   //   head: headers,
  //   //   body: rows,
  //   //   styles: { fontSize: 10 },
  //   //   headStyles: { fillColor: [220, 220, 220] },
  //   //   theme: "grid",            // draws full grid lines
  //   //   margin: { left: 40, right: 40 },
  //   //   tableWidth: pageWidth - 80
  //   // });

  //   // // 3) Total below table
  //   // const finalY = doc.lastAutoTable.finalY + 20;
  //   // doc.setFontSize(12);
  //   // // Open in new tab
  //   // doc.output("dataurlnewwindow");
  // };

  const formatAmount = (value) => {
    if (isNaN(value)) {
      return "0";
    }
    const num = parseFloat(value);
    return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  //Payment Block Added By Jaseem Hussain
  const submitpayments = () => {
    setModalShowPayment(false);
    setRefreshPaymentList(Date.now());
    // setModalShowTask(false);
    //fetchOffer(); //Added by Jaseem to Refresh Data.
    fetchData();
  };

//   const onPaymentListUpdate = (total) => {
//     setReceivedPayment(total);
// };






  return (
    <>
      <Main>
        {serviceOrder && (
        <Container className="pb-5" >
          {modalShow && (
            <Confirm
              show={modalShow}
              onHide={() => setModalShow(false)}
              deleteRecord={deleteRecord}
              title="Confirm delete?"
              message="You are going to delete the record. Are you sure?"
              table="serviceOrder"
            />
          )}
          <Row className="">
            <Col md={12} className="">
              <Breadcrumb>
                <Breadcrumb.Item onClick={() => navigate(ROUTES.HOME)}>Home</Breadcrumb.Item>
                <Breadcrumb.Item onClick={() => navigate(ROUTES.SERVICE_ORDER.LIST)} >Service Orders</Breadcrumb.Item>
              </Breadcrumb>
            </Col>
            <Col md={12}>
              <Row className="">
                <Col lg={12}>
                  <Card className="shadow">
                    <CardHeader className="card-header" style={{ background: "#1A293B", color: "white" }}>
                      <Row className="w-100"  >
                        <Col lg={6} className="" >
                          <div className="d-flex align-items-center h-100 gap-3" >
                            <h5 className="m-0">
                              Service Order
                            </h5>
                            <h5 className="m-0">
                              {serviceOrder.service_no || ""}
                            </h5>
                            
                          </div>
                        </Col>
                        <Col lg={6} className="p-0" >
                          <Stack direction="horizontal" className="float-end" gap={3}>
                            <h5 className="m-0">
                              Invoice Number
                            </h5>
                            <h5 className="m-0">
                              {serviceOrder.invoice_number || ""}
                            </h5>
                           
                            {/* <div ref={invoiceRef} style={{ padding: 20, background: "#fff", color: "#000" }}></div> */}
                            <Button
                              size="sm"
                              className="btn-edit"
                              onClick={() => editRecord(true)}
                            >
                              <i className="fa-regular fa-pen-to-square"></i>
                            </Button>

                            {/* {Permissionhelper.checkPermission(
                              constants.SUPER_ADMIN
                            ) && ( */}
                                <Button
                                  size="sm"
                                  className="btn-delete"
                                  onClick={() => setModalShow(true)}
                                >
                                  <i className="fa fa-trash-o"></i>
                                </Button>
                              {/* )} */}
                          </Stack>

                        </Col>
                      </Row>
                    </CardHeader>
                    <CardBody className="">
                      <Row className="view-form">
                        <Col lg={6}>
                          <label>Service Date</label>
                          <span>{formatDate(serviceOrder?.service_date)}</span>
                        </Col>
                        <Col lg={6}>
                          <label>Total Amount</label>
                          <span>{serviceOrder?.service_price || ""}</span>
                        </Col>
                        <Col lg={6}>
                          <label>Service Type</label>
                          <span>{serviceOrder?.service_type || ""}</span>
                        </Col>
                        <Col lg={6}>
                          <label>Remark</label>
                          <span>{serviceOrder?.remark || ""}</span>
                        </Col>
                        {/* <Col lg={6}>//comment by shahir hussain 22-05-2025
                          <label>Custom Invoice Number</label>
                          <span>{serviceOrder?.soiree_inv || ""}</span>
                        </Col> */}
                        {/* <Col lg={6}>
                          <label>System Generated Invoice Number</label>
                          <span style={{padding:'6px'}}>{serviceOrder?.invoice_number || ""}</span>
                        </Col> */}

                        {/* <Col lg={6}>
                          <label>Assigned User
                            <span style={{ padding: '1px' }}> */}
                              {/* Image Url for Production  */}
                              {/* <img src={`https://spark.indicrm.io/images/${userInfo.tenantcode}/users/${serviceOrder.ownerid}.thumbnail/${Math.random()}`} className="rounded-circle " style={{height: "20px", width: "20px", objectFit: "cover"}}/>   */}
                              {/* Image Url for Local  */}
                              {/* <img
                                src="https://www.w3schools.com/bootstrap4/img_avatar3.png"
                                className="rounded-circle"
                                style={{
                                  height: "30px",
                                  width: "30px",
                                  objectFit: "cover",
                                }}
                                alt=""
                              />
                              <img
                                src={localStorage.getItem("myimage")}
                                className="rounded-circle"
                                style={{ height: "30px" }}
                                alt=""
                              />

                              <Badge
                                bg="warning"
                                className="mx-2"
                                style={{ display: "inline", color: "#000" }}
                              >
                                {serviceOrder?.owner_name || ""}
                              </Badge>
                            </span>
                          </label>
                        </Col> */}
                        <Col lg={12} className="section-header mt-4">
                          AMOUNT INFORMATION
                        </Col>
                        <Col lg={6}>
                          <label>Total Amount</label>
                          <Badge
                            bg="secondary"
                            style={{
                              width: "30%",
                              fontWeight: "normal",
                              fontSize: "1rem",
                              textAlign: "left",
                            }}
                          >
                            {"₹ " +
                              formatAmount(
                                // serviceOrder?.order_amount
                                serviceOrder?.service_price
                                || 0
                              )}{" "}
                          </Badge>
                        </Col>
                        {/* <Col lg={6}>
              <label>Cheque Amount</label>
              <Badge
                bg="info"
                style={{
                  width: "30%",
                  fontWeight: "normal",
                  fontSize: "1rem",
                  textAlign: "left",
                }}
              >

                {"₹ " +
                  formatAmount(
                    serviceOrder?.cheque_amount || 0
                  )}
              </Badge>
            </Col> */}
                        {/* <Col lg={6}>
              <label>Cash Amount</label>
              <Badge
                bg="primary"
                style={{
                  width: "30%",
                  fontWeight: "normal",
                  fontSize: "1rem",
                  textAlign: "left",
                }}
              >
                {"₹ " +
                  formatAmount(
                    serviceOrder?.cash_amount || 0 //Added by shivani
                  )}
              </Badge>
            </Col> */}
                        <Col lg={6}>
                          <label>Received Amount</label>
                          <Badge
                            bg="success"
                            style={{
                              width: "30%",
                              fontWeight: "normal",
                              fontSize: "1rem",
                              textAlign: "left",
                            }}
                          >
                            {"₹ " +
                              formatAmount(
                                payments?.paidamount || 0 
                              )}
                          </Badge>
                        </Col>
                        <Col lg={6}>
                          <label>Pending Amount</label>

                          <Badge
                            bg="danger"
                            style={{
                              width: "30%",
                              fontWeight: "normal",
                              fontSize: "1rem",
                              textAlign: "left",
                            }}
                          >
                            {"₹ " +
                              formatAmount(
                                Math.max(
                                  0,
                                  serviceOrder?.service_price -
                                  (payments.paidamount || 0)
                                )
                              )}
                          </Badge>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>


            <Col md={12} >
              <Card bg="light" text="light" className="mb-2 mt-4 shadow">
                <Card.Header className="d-flex justify-content-between">
                  <Tabs
                    defaultActiveKey="files"
                    id="uncontrolled-tab-example"
                    onSelect={(key) => handleSelect(key)}
                  >
                    {/* <Tab eventKey="patienttests" title="Medical Tests"></Tab> */}
                    <Tab eventKey="files" title="Files"></Tab>
                    {/*<Tab eventKey="tasks" title="Tasks"></Tab> */}
                    <Tab eventKey="purchase_item" title="Service Line Item"></Tab>
                    <Tab eventKey="payment" title="Payment"></Tab>
                  </Tabs>

                  {relatedListPayment && (
                    <Button
                      size="sm"
                      className="btn-create"
                      onClick={() => setModalShowPayment(true)}
                    >
                      New Payment
                    </Button>
                  )}

                  {/* Modal Added By Jasem */}

                  {/* uncomment this button by shahir hussain for create a new file 16-05-2025 */}
                  {relatedListFiles && (
                    <Button
                      size="sm"
                      className="float-right btn-custom"
                      onClick={() => setModalShowFile(true)}
                    >
                      New File
                    </Button>
                  )}
                  {modalShowFile && (
                    <FilesCreate
                      show={modalShowFile}
                      onHide={() => setModalShowFile(false)}
                      parent={serviceOrder}
                      table="Contact"
                      submitFiles={submitFiles}
                    />
                  )} 

                  {modalShowPayment && (
                <PaymentEdit
                  show={modalShowPayment}
                  onHide={() => setModalShowPayment(false)}
                  parent={serviceOrder}
                  table="paymentTablel"
                  submitpayments={submitpayments}
                  pendingAmount={serviceOrder.service_price - (payments.total || 0)}
                // pendingAmount=  {(lead.order_amount - (payments.total || 0)) }
                />
              )}

                  {/* {relatedListTask && (
                    <Button
                      size="sm"
                      className="float-right btn-custom"
                      onClick={() => setModalShowTask(true)}
                    >
                      New Task
                    </Button>
                  )}
                  {modalShowTask && (
                    <TaskEdit
                      show={modalShowTask}
                      onHide={() => setModalShowTask(false)}
                      parentid={serviceOrder.id}
                      table="account"
                      submitTasks={submitTasks}
                    />
                  )} */}
                </Card.Header>
                <Card.Body>

                  {relatedListFiles && (
                    <RelatedListFiles
                      refreshFileList={refreshFileList}
                      parent={serviceOrder}
                      submitFiles={submitFiles}
                      table="Contact"

                    />
                  )}
                  
                  {relatedListPayment ? (
                    <PaymentRelatedList
                      refreshTaskList={refreshTaskList}
                      parent={serviceOrder}
                    />
                  ) : (
                    ""
                  )}

                  {purchaseLineItem ? (
                    <RelatedListServiceOrder
                      // refreshTaskList={refreshTaskList}
                      parent={serviceOrder}
                    />
                  ) : (
                    ""
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      )}
      </Main>
    </>
  );
};
export default ServiceOrderView;